<template>
  <!-- header -->
  <div class="position-fixed top-0 start-50 translate-middle-x w-100 mw-640 z-5 pb-1 bg-white">
    <div v-if="!check_if_client()" class="h-header w-100 d-flex align-items-center ps-4 pe-3">
      <header class="flex-grow-1 fs-6 text-muted d-flex align-items-center">
        <b>更多資訊</b>
      </header>
    </div>
  </div>

  <!-- main -->
  <main class="d-flex flex-column w-100 flex-1"
  :class="{'hideTitle': check_if_client()}">

    <div class="flex-1 p-4 flexCenter">
      <div class="w-100 text-center">
        <h6 class="text-secondary opacity-75">更多資訊尚無資料</h6>
        <small>更多資訊尚無資料</small>
      </div>
    </div>
    
    <!-- <div>
      <ul class="list-group list-group-flush">
        <li v-for="n in statistics" :key="n" class="list-group-item py-0">
          <div class="p-3 border-bottom d-flex justify-content-center align-items-center">
            <div class="me-4">
              {{n.title}}
            </div>
            <span v-if="n.data === 0" class="fs-5.5">{{n.data}}</span>
            <div v-else>
              <span v-if="n.title === '未付款訂單數量' || n.title === '未到貨訂單數量'"
                class="badge rounded-pill fs-6 danger-mix-black-20 bg-danger-subtle">{{n.data}}</span>
              <span v-else-if="n.title === '累計BV零售利潤' || n.title === '累計銷售總額'"
                class="fw-bolder primary-mix-black-30">${{n.data}}</span>
              <span v-else-if="n.title === '累計訂單數量'"
                class="badge rounded-pill fs-6 success-mix-black-20 bg-success-subtle">{{n.data}}</span>
              <span v-else class="badge rounded-pill fs-6 primary-mix-black-30 bg-primary-subtle">{{n.data}}</span>
            </div>
          </div>
        </li>
      </ul>

    </div> -->
  </main>
  </template>
  
  <script>
  // import { ref } from 'vue';
  // import _ from 'lodash';
  import liff from '@line/liff';

  export default {
    name: 'SettingCom',
    data() {
      return {
      }
    },
    methods: {
      check_if_client() {
        return liff.isInClient()
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>

  $spacer: 0.875rem;
  $headerHeight: calc($spacer * 3);
  $primary: #00a8ca;

  .h-header {
    height: $headerHeight;
  }
  main {
    margin: calc($headerHeight * 2) 0 69.5px;
    &.hideTitle {margin: $headerHeight 0 69.5px;}
  }
  .list-group-item {
    border: 0;
    &:last-child > * {
      border-bottom: none!important;
    }
  }
  </style>
  
  